import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { PageBannerContext } from "../../context/PageBannerContext";

export const HomepageHero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <PageBannerContext.Provider value={true} >
	  <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      py={2.5}
      bgcolor="#7aba43"
      width="100%"
    >
    </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          bgcolor: "white",
          width: "100%",
          height: { xs: 299, md: 593 },
          position: "relative",
          dataModelId: "204:595",
	      overflow:"hidden"
        }}
      >
        {/* Mountain background image */}
        <picture>
          <source media="(max-width: 899.95px)" srcSet="/images/heroHome/mobile-homepage-mountain.webp" />
          <Box
            component="img"
            sx={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "100%",
              height: { xs: 260, md: 520 },
              objectFit: "cover",
            }}
            alt=""
            fetchPriority="high"
            src="/images/heroHome/homepage-mountain.webp"
          />
        </picture>
	   <Box
              component="img"
              sx={{
                position: "absolute",
                width: {md:1440, xs:400},
                height: 113,
                bottom: {xs:-10, md:50},
                right: 0,
              }}
              alt=""
              src="/images/heroHome/vector-14.svg"
            />

	   {/* Bottom red bar */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: {xs: "10px", md: "25px"},
            bottom: {xs: "29px", md: "50px"},
            left: 0,
            backgroundColor: "#b65060",
          }}
        />

        {/* Hero woman image */}
        <picture>
          <source media="(max-width: 899px)" srcSet="/images/heroHome/hero-woman-mobile.webp" />
          <Box
            component="img"
            sx={{
              position: "absolute",
              width: { xs: 268, md: 531 },
              height: { xs: "auto", md: 592 },
              top: {xs:-2, md:0},
              left: {xs:-50, md:0},
              objectFit: "cover",
            }}
            alt=""
            src="/images/heroHome/hero-woman.webp"
          />
        </picture>
	  
	    <Typography variant="small" 
	  		
	  		sx={{
            position: "absolute", bottom:isMobile? "5px" : "20px", left:isMobile? "10px" : "220px", fontSize: {
              xs: "12px",
              md: "15px"
            }}}>
	  
	  		Not an actual patient.
	    </Typography>
	 
        {/* Main headline text */}
        <Typography
          className="label"
          variant="h1"
          sx={{
            position: "absolute",
            width: { xs: 'calc(100% - 195px)' , md: 314 },
            height: { xs: "auto", md: 54 },
            top: { xs: 20, md: 50 },
            left: { xs: 195, md: 546 },
            fontFamily: {
              xs: "Nunito Variable,Sofia Sans Variable",
              md: "Nunito Variable,Sofia Sans Variable"
            },
            fontWeight: {
              xs: "var(--mobile-eyebrow-font-weight)",
              md: 500
            },
            color: {
              xs: "#00295a",
              md: "#00295a"
            },
            fontSize: {
             xs: "clamp(12px, 3vw, 16px)",
              md: "1.25rem"
            },
            letterSpacing: {
              xs: "normal",
              md: "normal"
            },
            lineHeight: {
              xs: "1.1em",
              md: "normal"
            },
            fontStyle: {
              xs: "normal",
              md: "normal"
            },
          }}
        >
          ROS1+ NSCLC shouldn&apos;t make you feel like your life is on
          &quot;pause&quot;
        </Typography>

        {/* "PLAY ON" text */}
        <Typography
          sx={{
      position: "absolute",
      width: { xs: 181, md: 552 },
      height: { xs: "auto", md: 122 },
      top: { xs: 67, md: 90 },
      left: { xs: 192, md: 537 },
      fontFamily: "Nunito Variable,Sofia Sans Variable",
      fontWeight: 500,
      color: "#c35d6b",
      fontSize: {
      xs: 'clamp(28px, 8.5vw, 41px)',
      md: 'clamp(41px, 10vw, 122px)',
    },
      lineHeight: "normal",
      whiteSpace: "nowrap",
      '@media (min-width: 768px) and (max-width: 902px)': {
        width: 350,
        left: 450,
      },
    }}
        >
          PLAY ON
        </Typography>

        {/* Mobile-only decorative elements */}
        {isMobile && (
          <>
            <Box
              sx={{
                position: "absolute",
                width: 65,
                height: 25,
                top: 95,
                left: 68,
                backgroundImage: "url(/images/heroHome/layer-1.webp)",
                backgroundSize: "100% 100%",
              }}
            />
	  
	  
	  <Box
              component="img"
              sx={{
                position: "absolute",
                width: 100,
                height: "auto",
                bottom: 39,
                left: "calc(80% - 100px)",
                objectFit: "cover",
              }}
              alt=""
              src="/images/heroHome/homepage-dog-2880x1380-1.webp"
            />

           
          </>
        )}

        {/* Desktop-only elements */}
        {!isMobile && (
          <>
            
			
			{/* Decorative layer */}
        <Box
          sx={{
            position: "absolute",
            width: 130,
            height: 50,
            top: 184,
            left: 232,
            backgroundImage: "url(/images/heroHome/layer-1-2.webp)",
            backgroundSize: "100% 100%",
          }}
        />


           

            <Box
              component="img"
              sx={{
                position: "absolute",
                width: 223,
                height: 201,
                top: 319,
                left: "calc(75% - 300px)",
                objectFit: "cover",
              }}
              alt=""
              src="/images/heroHome/homepage-dog-2880x1380-1.webp"
            />
          </>
        )}

       

        {/* Progress bars */}
        <Box
          sx={{
            position: "absolute",
            width:{md: "calc(70% - 216px)", xs: "calc(90% - 32px)"},
            height: {md:"6px", xs: "3px"},
            top: {md: "241px", xs:"122px"},
            left: {md:"226px", xs: "40px"},
            backgroundColor: "#c35d6b",
            borderRadius: "3px",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width:{md: "calc(70% - 216px)", xs: "calc(90% - 32px)"},
            height: {md:"6px", xs: "3px"},
            top: {md: "250px", xs:"126px"},
            left: {md:"226px", xs: "40px"},
            backgroundColor: "#81c454",
            borderRadius: "3px",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "30%",
            height: {md:"6px", xs: "3px"},
            top: {md: "241px", xs:"122px"},
            left: {md:"calc(70% + 10px)", xs: "calc(90% + 10px)"},  
            backgroundColor: "#c35d6b",
            opacity: 0.4,
          }}
        />

        <Box
          sx={{
            position: "absolute",
            width: "30%",
            //height: "6px",
            //top: "250px",
			      height: {md:"6px", xs: "3px"},
            top: {md: "250px", xs:"125px"},
            left: {md:"calc(70% + 10px)", xs: "calc(90% + 10px)"}, 
            backgroundColor: "#81c454",
            opacity: 0.4,
          }}
        />

        {/* Arrow */}
        <Box
          component="img"
          src="/images/hero/arrow.svg"
          alt=""
          sx={{
            position: "absolute",
            width: {md: "24px", xs:"18px"},
            height: {md: "27px", xs:"auto"},
            top: {md: "235px", xs:"115px"},
            left: {md:"70%", xs:"90%"},
          }}
        />

        
        {/* Green holding shape */}
        <Box
          component="img"
          sx={{
            position: "absolute",
            
            top:  isMobile ? -2 : 0,
            left: isMobile ? -1 : 0,
			  width: isMobile ? 40 : 100,
          }}
          alt=""
          src="/images/hero/green-holding-shape.svg"
        />

      </Box>
    </PageBannerContext.Provider>
  );
};